export const tireCodes = [
    "A",
    "A1",
    "AR",
    "AS",
    "B",
    "B1",
    "BB",
    "BP",
    "C",
    "C1",
    "D",
    "E",
    "EP",
    "F",
    "F1",
    "FF",
    "G",
    "H",
    "HP",
    "I",
    "I1",
    "IB",
    "IB1",
    "IB2",
    "IB3",
    "K",
    "K1",
    "M",
    "M1",
    "MA",
    "MB",
    "MM",
    "MO",
    "MP",
    "N",
    "O",
    "P",
    "P1",
    "PM",
    "PP",
    "PR",
    "PS",
    "R",
    "RP",
    "S",
    "SA",
    "T",
    "V1",
    "V1ES",
    "V2",
    "V2ES",
    "XX"
]